import mySuxApi from '../services/dataSources/mySuxApi';

// constants
import { config } from '../config';

const URLS = config.URLS;

export function getBasketsForUser(userGuid, userId) {
  const url = `${URLS.MY_SOFOLOGY_API}${userGuid}/baskets/${userId}`;
  return mySuxApi.get(url).then(res => {
    if(!res.data || res.data === null) return [];
    return res.data;
  });
}



// WEBPACK FOOTER //
// ./src/services/basketService.js